import React, { useState } from 'react';

import styled from 'styled-components';

import { Gray, Purple } from 'constants/colors';

import { Icon } from '../icon';

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

const TooltipText = styled.div`
  position: absolute;
  bottom: 125%;
  left: 50%;
  transform: translateX(-50%);
  background-color: ${Gray[100]};
  color: ${Gray[400]};
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  opacity: ${(props) => (props.visible ? 1 : 0)};
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  transition: opacity 0.2s, visibility 0.2s;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #333;
  }
`;

export default ({
  text = null,
  icon = 'exclamationCircle',
  color = Purple[500],
  style = {},
  ...options
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!text) {
    return (
      <Icon
        icon={icon}
        width="16px"
        height="16px"
        style={{ margin: '0 0 0 5px', ...style }}
        color={color}
        {...options}
      />
    );
  }

  return (
    <TooltipContainer
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Icon
        icon={icon}
        width="18px"
        height="18px"
        style={{ margin: '0 0 0 5px', ...style }}
        color={color}
        {...options}
      />
      <TooltipText visible={showTooltip}>
        {text}
      </TooltipText>
    </TooltipContainer>
  );
};
